import { FoodItem, Label, Type } from "../types";
import { Rid } from "./restaurant";

export const foodList: FoodItem[] = [
  {
    id: "unniyappamfaloodarcp",
    name: "Unniyappam Falooda",
    type: Type.Veg,
    restaurantId: Rid.ChefPillai,
    labels: [Label.Dessert],
    image: "/images/unniyappamfalooda.jpg",
  },
  {
    id: "dynamiteprawnshc",
    name: "Dynamite Prawns",
    type: Type.NonVeg,
    restaurantId: Rid.HuddlesCafe,
    labels: [Label.Prawns],
    image: "/images/dynamiteprawns.jpg",
  },
  {
    id: "muttonburrakd",
    name: "Mutton Burra",
    type: Type.NonVeg,
    restaurantId: Rid.Karims,
    labels: [Label.Mutton],
    image: "/images/muttonburra.jpg",
  },
  {
    id: "venadpalkonjrcp",
    name: "Venad Palkonj",
    type: Type.NonVeg,
    restaurantId: Rid.ChefPillai,
    labels: [Label.Prawns],
    image: "/images/palkonjtemp.jpg",
  },
  {
    id: "bbqchickenhc",
    name: "BBQ Chicken",
    type: Type.NonVeg,
    restaurantId: Rid.HuddlesCafe,
    labels: [Label.Chicken],
    image: "/images/bbqchicken.jpg",
  },
  {
    id: "fishmangopg",
    name: "Fish Mango Curry",
    type: Type.NonVeg,
    restaurantId: Rid.Paragon,
    labels: [Label.Fish],
    image: "/images/fishmangocurry.jpg",
  },
  {
    id: "butterchickenad",
    name: "Butter Chicken",
    type: Type.NonVeg,
    restaurantId: Rid.AslamDelhi,
    labels: [Label.Chicken],
    image: "/images/butterchicken.jpg",
  },
  {
    id: "fishnirvanarcp",
    name: "Fish Nirvana",
    type: Type.NonVeg,
    restaurantId: Rid.ChefPillai,
    labels: [Label.Fish],
    image: "/images/fishnirvana.jpg",
  },
  {
    id: "chschnitzelhc",
    name: "Chicken Schnitzel",
    type: Type.NonVeg,
    restaurantId: Rid.HuddlesCafe,
    labels: [Label.Chicken, "Mushroom sauce"],
    image: "/images/schnitzel.jpg",
  },
  {
    id: "chkebabqk",
    name: "Chicken kebab",
    type: Type.NonVeg,
    restaurantId: Rid.Qureshi,
    labels: [Label.Chicken],
    image: "/images/chickenkebab.jpg",
  },
  {
    id: "troutgrill",
    name: "Grilled Trout",
    description: "When in doubt, Eat Trout",
    type: Type.NonVeg,
    restaurantId: Rid.Manali,
    labels: [Label.Fish],
    image: "/images/trout.jpg",
  },
  {
    id: "mtstewrcp",
    name: "Mutton stew",
    type: Type.NonVeg,
    restaurantId: Rid.ChefPillai,
    labels: [Label.Mutton],
    image: "/images/muttonstew.jpg",
  },
  {
    id: "ppchsteak",
    name: "Paprika Chicken Steak",
    type: Type.NonVeg,
    restaurantId: Rid.OldSkool,
    labels: [Label.Chicken],
    description: "Grilled chicken steak in creamy smoked paprika sauce",
    image: "/images/paprikachsteak.jpg",
  },
  {
    id: "crrocky",
    name: "Caribbean Rocky Road",
    type: Type.Veg,
    restaurantId: Rid.OldSkool,
    labels: [Label.Dessert],
    image: "/images/carribeanrocky.jpg",
    description:
      "Brownies, almonds, nougat and cookies drizzed in warm caramel fudge",
  },
];

export const getFood = (id) => foodList.find((food) => food.id === id);
